export default __webpack_public_path__ + "static/media/audlpm.71dea8fb.png";